import React from 'react';

export const ChevronUp = ({
  color,
  height,
  width
}: {
  color?: string;
  height?: string;
  width?: string;
}): JSX.Element => {
  const className = 'icon icon--chevron-up';
  color = color || '#0076CC';
  width = width || '16';
  height = height || '9';
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M1 8L8 0.999999L15 8"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronUp;
